import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import DashboardNavbar from "../Header";
import DashboardSidebar from "../Sidebar";
import { getCurrentUser, logout } from "../../api-config/config";
import { Route, useNavigate } from "react-router-dom";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  height: "100vh",
  paddingTop: `calc(${APP_BAR_MOBILE + 24}px + var(--group-booking-banner-height, 0px))`,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: `calc(${APP_BAR_DESKTOP + 24}px + var(--group-booking-banner-height, 0px))`,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const loggedUser = getCurrentUser();
  const checkUserToken = () => {
    if (loggedUser === null) {
      navigate("/login", { replace: true });
    }
  };
  useEffect(() => {
    checkUserToken();
  }, []);
  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
